// NOTE: need a way to keep the params (e.g. app=ios, USER_ID, etc)
// So that if the user logs out and go back to /signin, the params
// are still there.

import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from '../firebase';
import { Link, Redirect } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from 'react';
import { signIn } from '../audiblogsApi';
import userStore from '../Stores/User';
import queryString from 'query-string';
import mixpanel from 'mixpanel-browser';
import logo from '../logo.png';
import loading from '../Assets/loading.gif';
import { observer } from 'mobx-react';
import { version } from '../../package.json';
import OneGiftLogo from '../Components/OneGiftLogo';

const SignIn = observer(({ location, match }, props) => {
  const { logOut, user, firebaseUser, idToken } = userStore;
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [showHelpMsg, setShowHelpMsg] = useState(false);
  const [isNewUserSignup, setIsNewUserSignup] = useState(false);
  const params = useMemo(() => queryString.parse(location.search), [
    location.search,
  ]);
  const app = params.app;

  const uiConfig = {
    signInFlow: app === 'ios' ? 'redirect' : 'popup',
    // signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false,
      signInFailure: (error) => {
        if (error.code === 'auth/account-exists-with-different-credential') {
          // Handle linking here if needed
        }
      },
      signInSuccessWithAuthResult: (authResult) => {
        const isNewUser = authResult.additionalUserInfo.isNewUser;
        if (isNewUser) {
          setIsNewUserSignup(true);
          setShouldRedirect(true);
        }
        return false;
      },
    },
  };

  const redirectTo = useMemo(
    () =>
      isNewUserSignup
        ? params.redirected_from === 'landingB'
          ? '/onboarding/quickstart'
          : `/onboarding/ChooseVoice?app=${app}`
        : params.redirected_from === 'setup'
        ? '/setup'
        : params.redirected_from === 'newsletter'
        ? `/newsletter?article_url=${encodeURIComponent(
            params.article_url
          )}&article_title=${encodeURIComponent(params.article_title)}`
        : params.redirected_from === 'subscription'
        ? `/subscription?chars=${encodeURIComponent(params.chars)}`
        : params.redirected_from === 'link'
        ? `/link?email=${encodeURIComponent(params.email)}`
        : params.redirected_from === 'add'
        ? `/add?url=${encodeURIComponent(params.url)}`
        : params.redirected_from === 'setupnew'
        ? `/setupnew`
        : params.redirected_from === 'trial'
        ? `/add?article_url=${encodeURIComponent(params.article_url)}`
        : params.redirected_from === 'drawabox'
        ? `/drawabox`
        : params.redirected_from === 'onboarding'
        ? `/onboarding/howtoclip`
        : params.redirected_from === 'preferredVoices'
        ? `/preferredVoices`
        : params.redirected_from === 'onboarding/quickstart/2'
        ? `/onboarding/quickstart/2`
        : params.redirected_from === 'signup'
        ? '/onboarding/ChooseVoice'
        : '/',
    [params, isNewUserSignup]
  );

  useEffect(() => {
    mixpanel.track('Open Signin Page', params);
  }, []);

  useEffect(() => {
    if (user) {
      mixpanel.track('Sign Up');
      if (params.redirected_from === 'drawabox') {
        mixpanel.track('Successful Login Ater Subscription');
      } else {
        setShouldRedirect(true);
      }
    }

    if (firebaseUser && !firebaseUser.email) {
      logOut();
      alert(
        'Unable to get the email address. Please use a different sign-in method.'
      );
      // NOTE: this is a shitty UX for users. They get redirected to the landing page
      // And lose all the parameters (onboarding xml url or USER_ID, etc)
    }
  }, [
    firebaseUser,
    user,
    idToken,
    match.params.USER_ID,
    logOut,
    redirectTo,
    params.redirected_from,
  ]);

  if (shouldRedirect || userStore.isSignedIn) {
    // console.log('signedin');
    return <Redirect to={redirectTo} />;
  }

  if (params.app === 'ios') {
    // HACK: redirect to Shortcuts
    return <Redirect to={`/shortcuts`} />;
  }

  return (
    <div className="center">
      {userStore.isSignedIn === null ? (
        <img src={loading} style={{height: '50px'}}/>
      ) : (
        <>
          <a href="https://audioread.com/signin" target="_blank">
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                margin: '20px auto 0 auto',
                width: 'auto',
                height: '10vh',
              }}
            />
          </a>
          {!user ? (
            <>
              <h1 className="headline">
                {params.redirected_from === 'trial' ||
                params.redirected_from === 'drawabox'
                  ? "Let's create an account"
                  : 'Sign Up / Sign In'}
              </h1>

              <div>
                {match.params.USER_ID &&
                  'First time logging in? Your old feed will be imported into the new account.'}
              </div>
              <h2 className="subheadline">
                {/* Use the buttons below for both loggin in and signing up. */}
              </h2>
              <StyledFirebaseAuth
                uiConfig={uiConfig}
                firebaseAuth={firebase.auth()}
              />
            </>
          ) : (
            params.redirected_from === 'drawabox' && (
              <>
                <h1>All done!</h1>
                <a href="https://drawabox.com">Go back to Drawabox</a>
              </>
            )
          )}
        </>
      )}
      <div
        style={{
          marginTop: '50px',
        }}
      >
        {/* <button
          className="clickable"
          style={{
            display: !showHelpMsg ? 'block' : 'none',
            backgroundColor: 'transparent',
            border: '1px white solid',
            borderRadius: '5px',
            color: 'white',
            fontSize: '14px',
          }}
          onClick={(e) => {
            setShowHelpMsg(true);
          }}
        >
          Signin Issues?
        </button> */}
        <div style={{ display: showHelpMsg ? 'block' : 'none' }}>
          <div>1. Copy chrome://settings/cookies?search=cookie</div>
          <div>2. Paste it into the URL bar</div>
          <div>3. Select "Block third-party cookies in Incognito"</div>
        </div>

        <div>v{version}</div>
      </div>
      <div style={{ textAlign: 'center', paddingBottom: '20px', marginTop: 'auto' }}>
        <OneGiftLogo />
        <div className="footer-links" style={{ margin: '25px', display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/dmca">DMCA Policy</Link>
        </div>
        <div style={{ margin: '25px', opacity: 0.7 }}>© {new Date().getFullYear()} Audioread™. All rights reserved.</div>
      </div>
    </div>
  );
});

export default SignIn;
